import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '../..';
import { useBusinessEmployess } from '~/hooks/businesses';

export interface SelectEmployeeProps {
  businessId: string;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  value: string;
  name: string;
  label: string;
  [key: string]: any;
}

export const SelectEmployee = (props: SelectEmployeeProps) => {
  const { businessId, onChange, value, name, label, ...rest } = props;
  const translate = useTranslate();
  const td = (string: string) => translate(`utils.${string}`);
  const { data: employees } = useBusinessEmployess(businessId);
  const employeeOptions = employees
    ?.map((employee) => ({
      value: employee.id,
      text: `${employee.firstName} ${employee.lastName}`,
    }))
    .sort((a, b) => a.text.localeCompare(b.text));
  return (
    <SelectInput
      label={label}
      options={employeeOptions ?? []}
      onChange={onChange}
      value={value || ''}
      name={name}
      allowEmpty
      emptyText={td('any')}
      {...rest}
    />
  );
};
